import { Avatar, AvatarFallback } from '@/components/ui/avatar'
import { Badge } from '@/components/ui/badge'
import { useAgentName } from './agentName'

/** The agent's tab before the agent is there, holding the shape of the account. */
export function AgentComingSoon() {
  const agentName = useAgentName()

  return (
    <div className="flex h-full flex-1 flex-col items-center justify-center gap-4 p-6">
      <Avatar className="bg-brand-100 size-14 rounded-xl opacity-60">
        <AvatarFallback className="bg-brand-100 rounded-xl" />
      </Avatar>
      <Badge variant="secondary" className="text-[10px]">
        Coming soon
      </Badge>
      <p className="text-ink-500 max-w-sm text-center text-sm leading-relaxed">
        {agentName} will soon be able to answer questions and assist you with insurance, finance, compliance
        and more.
      </p>
    </div>
  )
}
